/* eslint-disable import/no-unresolved */
import ContextMenu from "pages/_components/ContextMenu";
import { resizableRoute } from "pages/_components/Resizable";
import TransactionTicket from "pages/_components/TransactionTicket";
import ModifyPendingTransactionModal from "pages/transactions/_components/ModifyPendingTransactionModal";
import { bool, func, shape } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { push } from "react-router-redux";
import { actions as transferActions, selectors as transferSelectors } from "reducers/transfer";

import { actions as formActions } from "reducers/form";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as transactionsActions, selectors as transactionsSelectors } from "reducers/transactions";
import * as i18n from "util/i18n";
import { isUxDashboardImprovementsEnabled } from "util/v3ShellLayoutSync";
import { exportGenericTicketPdfWithSuccessMessage, getGeneralTicketItem } from "util/transaction";
import { getDebitAccountTicketLabel } from "util/accounts";
import ExternalTransactionData from "./ExternalTransactionData";
import ExternalTransactionSummaryData from "./ExternalTransactionSummaryData";

class ExternalTransaction extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        summary: shape({}).isRequired,
        isDesktop: bool.isRequired,
        fetching: bool.isRequired,
        getAccountInfo: shape({}).isRequired,
        activeEnvironment: shape({}).isRequired,
    };

    state = {
        isModalDisplayed: false,
        showDrawerMobile: false,
        fetchingDownload: false,
    };

    componentDidMount() {
        const { summary, dispatch } = this.props;
        if (!summary?.idTransaction) {
            dispatch(push("/pendingTransaction/list"));
        } else {
            // Se obtienen los potencial signatures
            dispatch(transactionsActions.getPotentialSignaturesData(summary?.idTransaction));
            // Se lee la cuenta de debito para mostrar el shortLabel
            dispatch(transferActions.getAccountInfo(summary?.debitAccount, "debit", true));
        }
    }

    generateTicketBody = () => {
        const {
            summary: { beneficiaryName, amount, currency, concept, creditAccount, idActivityOriginal },
            getAccountInfo,
            activeEnvironment,
        } = this.props;

        const data = [];
        data.push(getGeneralTicketItem("transferSummary.payer.label", activeEnvironment?.name, "string"));
        data.push(
            getGeneralTicketItem(
                "transfers.debitAccount.label",
                getAccountInfo && getDebitAccountTicketLabel(getAccountInfo),
                "string",
            ),
        );
        data.push(
            getGeneralTicketItem(
                "transfers.creditAccount.label",
                (creditAccount && creditAccount.slice(-14, -1)) || "",
                "string",
            ),
        );

        data.push(
            getGeneralTicketItem(
                "transactions.list.filters.transaction.activity.label",
                i18n.get(`activity.${idActivityOriginal}`),
                "string",
            ),
        );

        data.push(getGeneralTicketItem("transferSummary.cbuOrCvu.label", creditAccount, "string"));

        data.push(getGeneralTicketItem("transferSummary.cuit.label", this.getCuitDescription(), "string"));

        data.push(getGeneralTicketItem("transferSummary.owner.label", beneficiaryName || "", "string"));
        const amountValue = amount?.quantity || amount;
        const currencyValue = currency?.toString() || (amount?.currency ? amount.currency.toString() : "");
        data.push(
            getGeneralTicketItem(
                "transfers.amount.label",
                amountValue,
                `amount${i18n.get(`currency.label.${currencyValue}`)}`,
            ),
        );

        if (concept) {
            data.push(
                getGeneralTicketItem(
                    "transfers.concept.label",
                    `${concept} - ${i18n.get(`transfers.concept.${concept}`)}`,
                    "string",
                ),
            );
        }
        return data;
    };

    handleDownload = async () => {
        const { dispatch, summary } = this.props;

        this.setState({ fetchingDownload: true });

        const ticketMessage =
            summary.tadTrx && summary.idTransactionStatus !== "FAILED"
                ? i18n.get("transfer.TAD.summary.thirdPartiesTransfer")
                : undefined;

        const ticketData = {
            ticketName: i18n.get(this.getTitle()),
            ticketBody: [...this.generateTicketBody()],
            ticketMessage,
        };

        await exportGenericTicketPdfWithSuccessMessage(ticketData, dispatch, i18n.get("global.download.success"));

        this.setState({ fetchingDownload: false });
    };

    centerContentMobile = () => (
        <div className="title-account-header-multiline-background-blue">
            <h1 className="w-100 m-0 px-2">{i18n.get("external.transaction.summary.label")}</h1>
        </div>
    );

    getTitle = () => "external.transaction.summary.label";

    signTransaction = () => {
        const { dispatch, summary, isDesktop, getAccountInfo } = this.props;
        const { idActivity } = summary;
        const title = this.getTitle();

        const signTransactionData = (
            <ExternalTransactionSummaryData getAccountInfo={getAccountInfo} signature isDesktop={isDesktop} />
        );

        dispatch(push("/transactions/sign"));
        dispatch(
            formActions.signTransactionData({
                idTransaction: summary?.idTransaction,
                idActivity,
                idForm: "",
                content: signTransactionData,
                title,
                pendingDispatch: summary?.pendingDispatch,
            }),
        );

        dispatch(
            formActions.signTransactionPreview({
                idActivity,
                idTransaction: summary.idTransaction,
                idForm: "",
                ticketData: summary,
            }),
        );

        dispatch(transferActions.loadExternalTransfer({ ...summary, action: "sign" }));
    };

    handleDismiss = () => {
        this.setState({ isModalDisplayed: false });
    };

    rightContentTransactionScheme = (isFinished) => {
        const { isDesktop, summary } = this.props;

        if (isDesktop || isFinished) {
            return <></>;
        }

        return (
            <>
                {summary?.idTransactionStatus !== "CANCELLED" ||
                    (summary?.idTransactionStatus !== "FAILED" && (
                        <ContextMenu
                            isDesktop={isDesktop}
                            color="white"
                            buttonClassName="align-self-center account-dropdown-header-font font-black-alpha ml-2"
                            items={[
                                {
                                    label: "pendingTransaction.info.scheme",
                                    onClick: () => this.setState({ showDrawerMobile: true }),
                                },
                            ]}
                        />
                    ))}
            </>
        );
    };

    buttonsDetailPending = () => [];

    buttonsDetailFinished = () => {
        const { dispatch, summary } = this.props;
        const { fetchingDownload } = this.state;
        const buttons = [];
        const isFinished = summary.idTransactionStatus === "FINISHED";

        if (isFinished) {
            buttons.push({
                label: "global.download.ticket",
                bsStyle: "outline",
                loading: { fetchingDownload },
                onClick: () => this.handleDownload("pdf"),
            });
        }

        buttons.push({
            label: "global.goToHome",
            bsStyle: "primary",
            onClick: () => dispatch(push("/desktop")),
        });

        return buttons;
    };

    getCuitDescription = () => {
        const { summary } = this.props;
        if ((summary?.beneficiaryDocumentType === "CUIL") !== undefined) {
            return ` ${i18n.get(`transferSummary.cuil.input.label`)} ${summary.beneficiaryDocumentNumber}`;
        }
        return ` ${i18n.get(`transferSummary.cuit.input.label`)} ${summary.beneficiaryDocumentNumber}`;
    };

    render() {
        const { isDesktop, dispatch, summary, fetching } = this.props;
        const { isModalDisplayed, showDrawerMobile, fetchingDownload } = this.state;

        const isFinished = summary.idTransactionStatus === "FINISHED";
        const isPending = summary.idTransactionStatus === "PENDING";
        const uxDashboardImprovements = isUxDashboardImprovementsEnabled();

        return (
            <TransactionTicket
                notificationScope="pendingTransfer"
                handleClick={this.handleDownload}
                handleClickMessage="global.download"
                headerClassName={!isDesktop ? "blue-main-header-mobile blue-main-title-mobile" : ""}
                centerElement={isDesktop ? undefined : this.centerContentMobile}
                uniqueDownload={false}
                rightContent={() => this.rightContentTransactionScheme(isFinished)}
                hasInlineButtons
                hideMobileMenu={!isDesktop}
                summary={summary}
                buttonsDetail={isPending ? this.buttonsDetailPending() : this.buttonsDetailFinished()}
                isDesktop={isDesktop}
                onSignTicket={this.signTransaction}
                summaryTitle={this.getTitle()}
                closeMobileDrawer={() => this.setState({ showDrawerMobile: false })}
                showDrawerMobile={showDrawerMobile}
                isFetchingExport={fetchingDownload}
                fetching={fetching}
                ignoreHomeButton
                downloadImageWhite={!isDesktop}
                embeddedInV3Shell={uxDashboardImprovements}
                embeddedV3GoBackPath={uxDashboardImprovements ? "/pendingTransaction/list" : undefined}>
                <ModifyPendingTransactionModal
                    isDesktop={isDesktop}
                    isDisplayed={isModalDisplayed}
                    handleDismiss={this.handleDismiss}
                    dispatch={dispatch}
                    idTransaction={summary.idTransaction}
                    cancelTransactionData={() => <ExternalTransactionSummaryData signature isDesktop={isDesktop} />}
                />
                <ExternalTransactionData />
            </TransactionTicket>
        );
    }
}

const mapStateToProps = (state) => ({
    summary: transactionsSelectors.getSummary(state),
    fetching: transferSelectors.getFetching(state),
    potentialSignaturesData: transactionsSelectors.getPotentialSignaturesData(state),
    getAccountInfo: transferSelectors.getDebitAccount(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});

export default compose(connect(mapStateToProps), resizableRoute)(ExternalTransaction);
